import { UseFormProps, UseFormReturn, useForm as useHookForm } from 'react-hook-form'

export const useForm = ({ ...args }: UseFormProps): UseFormReturn => {
  const form = useHookForm(args)
  return {
    ...form,
  }
}
